var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wx_loginAll"},[_c('van-skeleton',{attrs:{"title":"","avatar":"","avatar-size":48,"row":9,"round":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }